import React from 'react';
import logoImage from '@/assets/images/logo.png';

export const AppLogo = ({ height, width, ...props }) => (
  <img
    src={logoImage}
    alt="Escribanía Passerini"
    height={height}
    width={width}
    {...props}
  />
)